export function toSelectItems(stringArr = [], format = v => v) {
  return stringArr.reduce((acc, value) => [...acc, { caption: format(value), value }], []);
}

export function entitiesToSelectItems(entitiesArr = []) {
  return entitiesArr.reduce(
    (acc, { displayName, id }) => [...acc, { caption: displayName || "Missing display_name", value: id }],
    [],
  );
}
